// extracted by css-extract-rspack-plugin
export default {"stepper":"OnboardingStepper_stepper__0rK8m"};